import { TFunction } from 'i18next';
import * as yup from 'yup';

export const resetPasswordValidationSchema = (t: TFunction) =>
  yup.object().shape({
    password: yup
      .string()
      .required(t('auth.password-required'))
      .min(8, t('auth.password-min-length', { count: 8 }))
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
        t('auth.password-strength-message')
      ),
    confirmPassword: yup
      .string()
      .required(t('auth.confirm-password-required'))
      .oneOf([yup.ref('password')], t('auth.passwords-must-match')),
  });
